// extracted by mini-css-extract-plugin
module.exports = {"header":"WorkspacesBox_header__ejeld","box":"WorkspacesBox_box__1P0MM","node":"WorkspacesBox_node__3HaYU"};